var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.817 1V0.5H27.317H23.8735H23.3735V1V23.156H1.58594H1.08594V23.656V26.536V27.036H1.58594H23.3735V49.096V49.596H23.8735H27.317H27.817V49.096V27.036H49.5089H50.0089V26.536V23.656V23.156H49.5089H27.817V1Z",
    fill: "#828282",
    stroke: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluse);
export default __webpack_public_path__ + "static/media/pluse.c1c2f9d896f653f4d1919f93315a7997.svg";
export { ForwardRef as ReactComponent };